import React from 'react'
import {Modal} from 'react-bootstrap'

interface Props {
    show: boolean
    currentVersion: string
    latestVersion: string
    onConfirm: () => void
    onCancel: () => void
}

export function UpdateConfirmationDialog({show, currentVersion, latestVersion, onConfirm, onCancel}: Props) {
    if (!show) return null

    return (
        <Modal show={show} backdrop='static' keyboard={false} centered>
            <Modal.Body className='p-10'>
                <div className='text-center mb-8'>
                    <div className='symbol symbol-80px mb-6'>
                        <div className='symbol-label bg-light-warning'>
                            <i className='ki-duotone ki-arrow-up fs-3x text-warning'>
                                <span className='path1'></span>
                                <span className='path2'></span>
                            </i>
                        </div>
                    </div>
                    <h2 className='fw-bold mb-3'>Confirm Update</h2>
                    <p className='text-gray-600 fs-6 mb-0'>
                        You are about to update the application to a new version.
                    </p>
                </div>

                <div className='bg-light-primary p-5 rounded-3 mb-5'>
                    <div className='d-flex justify-content-between align-items-center mb-3'>
                        <span className='text-gray-600 fw-semibold fs-7'>Current Version</span>
                        <span className='badge badge-light-danger fs-7 fw-bold'>{currentVersion}</span>
                    </div>
                    <div className='d-flex justify-content-between align-items-center'>
                        <span className='text-gray-600 fw-semibold fs-7'>New Version</span>
                        <span className='badge badge-light-success fs-7 fw-bold'>{latestVersion}</span>
                    </div>
                </div>

                <div className='mb-5'>
                    <h5 className='fw-bold text-dark fs-6 mb-3'>What will happen:</h5>
                    <div className='d-flex flex-column gap-3'>
                        <div className='d-flex align-items-start'>
                            <div className='symbol symbol-25px me-3 mt-1'>
                                <div className='symbol-label bg-light-primary'>
                                    <i className='ki-duotone ki-cloud-download fs-7 text-primary'>
                                        <span className='path1'></span>
                                        <span className='path2'></span>
                                    </i>
                                </div>
                            </div>
                            <span className='text-gray-700 fs-7'>
                                The latest version will be downloaded and installed automatically.
                            </span>
                        </div>
                        <div className='d-flex align-items-start'>
                            <div className='symbol symbol-25px me-3 mt-1'>
                                <div className='symbol-label bg-light-warning'>
                                    <i className='ki-duotone ki-arrows-loop fs-7 text-warning'>
                                        <span className='path1'></span>
                                        <span className='path2'></span>
                                    </i>
                                </div>
                            </div>
                            <span className='text-gray-700 fs-7'>
                                The application will restart once the update is installed.
                            </span>
                        </div>
                        <div className='d-flex align-items-start'>
                            <div className='symbol symbol-25px me-3 mt-1'>
                                <div className='symbol-label bg-light-success'>
                                    <i className='ki-duotone ki-shield-tick fs-7 text-success'>
                                        <span className='path1'></span>
                                        <span className='path2'></span>
                                    </i>
                                </div>
                            </div>
                            <span className='text-gray-700 fs-7'>
                                All your data is safe. No data will be lost during this process.
                            </span>
                        </div>
                    </div>
                </div>

                <div className='bg-light-danger p-4 rounded-3 mb-8 border border-danger border-dashed'>
                    <div className='d-flex align-items-center'>
                        <i className='ki-duotone ki-information-3 fs-2 text-danger me-3'>
                            <span className='path1'></span>
                            <span className='path2'></span>
                            <span className='path3'></span>
                        </i>
                        <div>
                            <div className='text-danger fw-bold fs-7'>Application will go offline</div>
                            <div className='text-gray-600 fs-8'>
                                The application will be unavailable for approximately 5 minutes during the update. Please make sure no active operations are in progress.
                            </div>
                        </div>
                    </div>
                </div>

                <div className='d-flex gap-3'>
                    <button
                        type='button'
                        className='btn btn-light flex-grow-1'
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                    <button
                        type='button'
                        className='btn btn-warning flex-grow-1'
                        onClick={onConfirm}
                    >
                        <i className='ki-duotone ki-arrow-up fs-4 me-1'>
                            <span className='path1'></span>
                            <span className='path2'></span>
                        </i>
                        Yes, Update Now
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    )
}
